var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditWatchedItem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "write") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dabas-Logged-In-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logged-In-UI",
    transform: "translate(-1222.000000, -303.000000)",
    fill: "#0B3358",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(148.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table-Search-Results",
    transform: "translate(0.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product-table-item"
  }, /*#__PURE__*/React.createElement("g", {
    id: "write"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1074.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3947368,20 L0.855263158,20 C0.384868421,20 0,19.6151316 0,19.1447368 L0,4.60526316 C0,4.13486842 0.384868421,3.75 0.855263158,3.75 L6.84210526,3.75 C7.3125,3.75 7.69736842,4.13486842 7.69736842,4.60526316 C7.69736842,5.07565789 7.3125,5.46052632 6.84210526,5.46052632 L1.71052632,5.46052632 L1.71052632,18.2894737 L14.5394737,18.2894737 L14.5394737,12.3026316 C14.5394737,11.8322368 14.9243421,11.4473684 15.3947368,11.4473684 C15.8651316,11.4473684 16.25,11.8322368 16.25,12.3026316 L16.25,19.1447368 C16.25,19.6151316 15.8651316,20 15.3947368,20 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.970588235,14.7428571 C0.75,14.7428571 0.529411765,14.6571429 0.352941176,14.4857143 C0.132352941,14.2714286 0.0441176471,14.0142857 0.0882352941,13.7571429 L0.794117647,9.47142857 C0.838235294,9.3 0.926470588,9.12857143 1.05882353,9 L9.70588235,0.557142857 C10.0588235,0.214285714 10.5882353,0.214285714 10.9411765,0.557142857 L14.6911765,4.15714286 C14.8676471,4.32857143 14.9558824,4.54285714 14.9558824,4.75714286 C14.9558824,4.97142857 14.8676471,5.18571429 14.6911765,5.35714286 L6,13.8 C5.86764706,13.9285714 5.69117647,14.0142857 5.51470588,14.0571429 L1.10294118,14.7428571 C1.05882353,14.7 1.01470588,14.7428571 0.970588235,14.7428571 Z M2.47058824,9.98571429 L2.02941176,12.8571429 L4.98529412,12.3857143 L12.7941176,4.75714286 L10.3235294,2.35714286 L2.47058824,9.98571429 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5147059,7.84285714 C11.2941176,7.84285714 11.0735294,7.75714286 10.8970588,7.58571429 L7.45588235,4.24285714 C7.10294118,3.9 7.10294118,3.38571429 7.45588235,3.04285714 C7.80882353,2.7 8.33823529,2.7 8.69117647,3.04285714 L12.1323529,6.38571429 C12.4852941,6.72857143 12.4852941,7.24285714 12.1323529,7.58571429 C11.9558824,7.75714286 11.7352941,7.84285714 11.5147059,7.84285714 Z",
    id: "Path"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWatchedItem);
export default __webpack_public_path__ + "static/media/edit-watched-item.64120a55148cf93f366950b2ae9519b4.svg";
export { ForwardRef as ReactComponent };